import clsx from 'clsx'
import Clickable from 'components/Common/Clickable'
import { mediaHoverable } from 'lib/theme/mediaQueries'
import React, { ComponentProps, RefAttributes } from 'react'
import styled from 'styled-components'
import interactiveFocusStyle from 'styles/utils/interactiveFocusStyle'
import _ListItem from './_ListItem'
import NestableClickable from 'components/Common/NestableClickable'

const Container = styled(_ListItem)`
  &.selected {
    background-color: ${props => props.theme.palette.highlight.secondary.lightBackground};
  }

  &:disabled {
    color: ${props => props.theme.palette.neutral.default.four};
  }

  &:not(:disabled) {
    ${mediaHoverable} {
      &:hover {
        cursor: pointer;
        background-color: ${props => props.theme.palette.neutral.default.seven};
      }
    }

    &:focus {
      ${interactiveFocusStyle}
    }
  }
`

type InheritedClickableProps = Omit<ComponentProps<typeof Clickable>, 'ref' | 'title' | 'as' | 'forwardedAs'>
type InheritedBaseListItemProps = Omit<ComponentProps<typeof _ListItem>, 'ref' | 'as' | 'forwardedAs'>
interface Props extends InheritedClickableProps, InheritedBaseListItemProps, RefAttributes<HTMLButtonElement | HTMLAnchorElement | HTMLElement> {
  /** Whether the list item should be in a selected state or not */
  selected?: boolean
}

function NestableClickableListItem({
  className,
  selected,
  ...rest
}: Props) {
  return <Container
    {...rest}
    className={clsx(className, { selected })}
    forwardedAs={NestableClickable as any}
  />
}

export default NestableClickableListItem
